<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>

    <v-flex>
      <core-upsert
        title='Create a new protocol'
        :config="config"
        @saved="saved">

         <template slot='headerActions'>
          
          <v-btn
            color="secondary"
            @click="$router.push('/protocol')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </template>

       
      </core-upsert>

      
    </v-flex>

  </v-container>
</template>

<script>

import config from './config_index.js'

export default {
  data () {
    return {
      config
    }
  },
  methods: {
    saved ({ data }) {
      this.$router.push(`/protocol/${data.id}`)
    }
  }
}
</script>
